import {
    MemoryStorage,
    CookieStorage,
    LocalStorage,
    SessionStorage,
} from "@sopheos/orbjs_storage";

import helperHttp from "./footer/helperHttp.mjs";
import admanager from "./footer/admanager.js";
import agwHelpers from "./footer/agwHelpers.js";
import snackbar from "./footer/snackbar.mjs";

let storage_prefix = "";
switch (window.CONFIG.env) {
    case "developpement":
        storage_prefix = `DEV_AGENDAWEB`;
        break;
    case "testing":
        storage_prefix = `TESTING_AGENDAWEB`;
        break;
    default:
        storage_prefix = "AGENDAWEB";
        break;
}

window.useMemoryStorage = new MemoryStorage();
window.useCookieStorage = new CookieStorage();
window.useLocalStorage = new LocalStorage(storage_prefix);
window.useSessionStorage = new SessionStorage(storage_prefix);
